"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoalType = exports.Period = exports.PeriodFormat = exports.SERVICE_NAME = void 0;
// Used by other services to reference this one in the dependency map
exports.SERVICE_NAME = 'student-activity-service';
var PeriodFormat;
(function (PeriodFormat) {
    PeriodFormat["day"] = "yyyy-MM-dd";
    PeriodFormat["week"] = "kkkk-WW";
    PeriodFormat["month"] = "yyyy-MM";
})(PeriodFormat = exports.PeriodFormat || (exports.PeriodFormat = {}));
// Attention - week is only view period & it is not stored in dynamo
var Period;
(function (Period) {
    Period["day"] = "day";
    Period["week"] = "week";
    Period["month"] = "month";
})(Period = exports.Period || (exports.Period = {}));
var GoalType;
(function (GoalType) {
    GoalType["xp"] = "xp";
})(GoalType = exports.GoalType || (exports.GoalType = {}));
//# sourceMappingURL=index.js.map